import { sleep } from '../../helpers/index.js';


const RESP_TIMEOUT = 5000; //ms
const SCAN_TIMEOUT = 15000; //ms
const ARM_MOVE_WAIT = 200; //ms
const ARM_POS_MAX = 15; // cm
const DRIVE_SPEED_MAX = 255; // 0-255

//const HRD_B1 = 0x55;
//const HRD_B2 = 0xAA;
const TIMEOUT_MAX = 3000;

class LocoRover {
  
    constructor() {
        this.port = null;
        this.reader = null;
        this.writer = null;

        this.read_loop = {
            targetLen: 0,
            targetLenOff: 0,
            header: 0,
            hasTargetLength: false,
            hasHeader: false,
        }
        
        this.read_buffer = {
            data: [],
        }

        this.DATA_TYPE = Object.freeze({
            TRACKING_DATA: 0x01,
            ULTRASONIC_DATA: 0x02,
            ACC_DATA: 0x03,
            GYRO_DATA: 0x04,
            EULER_DATA: 0x05,
        });

        this.robotData = {
            scanEnd: false,
            scanData: [],
            connectEnd: false,
            connectState: 0,
            connectFirmware: false,
            ptFWVersion: 0,
            ptFWRevision: 0,
            receivedData: false,
            waitFlag: false,
            waitData: "",
            messageData: {
                [this.DATA_TYPE.ACC_DATA]: {
                    x: 0, y: 0, z: 0
                },
                [this.DATA_TYPE.GYRO_DATA]: {
                    x: 0, y: 0, z: 0
                },
                [this.DATA_TYPE.EULER_DATA]: {
                    roll: 0, pitch: 0, yaw: 0
                },
                [this.DATA_TYPE.ULTRASONIC_DATA]: {
                    distance: 0
                },
                [this.DATA_TYPE.TRACKING_DATA]: {
                    left: 0, middle: 0, right: 0
                }
            }
        };

        this.timeout_count = 0

        this.CONNECT_STATES = {
            CONNECT_FAIL: 0,
            CONNECT_OK: 1 
        };

        this.bufferSize = 100;

        this.lrTimeoutID = null;
        this.can_process = false;

        this.LR_NOTE_MAPPING = Object.freeze({
            "C": 0x00,
            "C#": 0x01,
            "D": 0x02,
            "D#": 0x03,
            "E": 0x04,
            "F": 0x05,
            "F#": 0x06,
            "G": 0x07,
            "G#": 0x08,
            "A": 0x09,
            "A#": 0x0A,
            "B": 0x0B,
        });
        
        this.LR_DRIVE_MAPPING = Object.freeze({
            Forward: 163,
            Backward: 92,
            Move_Left: 106,
            Move_Right: 149,
            Top_Left: 34,
            Bottom_Left: 72,
            Top_Right: 129,
            Bottom_Right: 20,
            Stop: 0,
            Contrarotate: 83,
            Clockwise: 172,
        });
        
        this.LOCOROVER_MSGS = Object.freeze({
            SSID_LIST_ITEM: 84, // ASCII for 'T'
            SSID_LIST_END: 85,  // ASCII for 'U'
            WIFI_CONNECT: 67,   // ASCII for 'C'
            WIFI_DISCONNECT: 68, // ASCII for 'D'
            WIFI_PASSTHROUGH: 80, // ASCII for 'P'
            WIFI_SCAN: 83,      // ASCII for 'S'
            PT_VERSION: 86,     // ASCII for 'V'
            DEBUG_PACKET: 66,   // ASCII for 'B'
        });
        
        this.PACKET_TYPE = Object.freeze({
            DRIVE_PACKET: 0x01,
            ARM_PACKET: 0x02,
            DATA_PACKET: 0x03,
            SOUND_PACKET: 0x04,
            LIGHTS_PACKET: 0x05,
            PREDEF_PACKET: 0x06,
            INFO_PACKET: 0x07,
        });
        
        this.ARM_TYPE = Object.freeze({
            ARM_ANGLES: 0x01,
            ARM_POSITION: 0x02,
        });
        
        
        this.INFO_TYPE = Object.freeze({
            VERSION: 0x01,
        });
        
        this.PREDEF_TYPE = Object.freeze({
            LIGHTS_EFFCT: 0x01,
            SOUND_EFFCT: 0x02,
        });
        
        this.SOUND_FX_TYPE = Object.freeze({
            PULSE: 0x01,
            TOGGLE: 0x02,
            STOP: 0x03,
        });
        
        this.LIGHT_FX_TYPE = Object.freeze({
            PULSE: 0x01,
            TOGGLE: 0x02,
            ROTATE: 0x03,
            STOP: 0x04,
        });

        this.debug_time = null;

        this.bufferSize = 100;

        this.optionNames = [
            'Attitude', 'Ultrasonic', 'Accelerometer', 'Gyroscope','Track Sensors'
        ];

        this.options = {
            'Attitude': {refer: 'READ_ATT', count: 3, range: ['min', 'min', 'min'], offset: 2},
            'Ultrasonic': {refer: 'READ_ULTRA', count: 1, range: ['fixed'], fixed: [0, 150]},
            'Accelerometer': {refer: 'READ_ACC', count: 3, range: ['min', 'min', 'min'], offset: 2},
            'Gyroscope': {refer: 'READ_GYR', count: 3, range: ['min', 'min', 'min'], offset: 2},
            'Track Sensors': {refer: 'READ_TRACK', count: 3, range: ['min', 'min', 'min'], offset: 2}
        };

        
        this.self = {
            READ_ATT: {
                value: this.DATA_TYPE.EULER_DATA,
                names: ['Roll', 'Pitch', 'Yaw'],
                ylabels: ["Roll (deg)", "Pitch (deg)", "Yaw (deg)"],
                arrays: ['rArray', 'pArray', 'yArray'],
            },
            READ_ULTRA: {
                value: this.DATA_TYPE.ULTRASONIC_DATA,
                names: ['Distance'],
                ylabels: ["Distance (cm)"],
                arrays: ['uArray'],
            },
            READ_ACC: {
                value: this.DATA_TYPE.ACC_DATA,
                names: ['Acc X', 'Acc Y', 'Acc Z'],
                ylabels: ["X (g)", "Y (g)", "Z (g)"],
                arrays: ['axArray', 'ayArray', 'azArray'],
            },
            READ_GYR: {
                value: this.DATA_TYPE.GYRO_DATA,
                names: ['Gyr X', 'Gyr Y', 'Gyr Z'],
                ylabels: ["X (dps)", "Y (dps)", "Z (dps)"],
                arrays: ['gxArray', 'gyArray', 'gzArray'],
            },
            READ_TRACK: {
                value: this.DATA_TYPE.TRACKING_DATA,
                names: ['Track L', 'Track M', 'Track R'],
                ylabels: ["L (#)", "M (#)", "R (#)"],
                arrays: ['tLArray', 'tMArray', 'tRArray'],
            },
            rArray: [],
            pArray: [],
            yArray: [],
            uArray: [],
            axArray: [],
            ayArray: [],
            azArray: [],
            gxArray: [],
            gyArray: [],
            gzArray: [],
            tLArray: [],
            tMArray: [],
            tRArray: [],
        };
    
    }

    resetArrays = () => {
        this.self.rArray = []
        this.self.pArray = []
        this.self.yArray = []
        this.self.uArray = []
        this.self.axArray = []
        this.self.ayArray = []
        this.self.azArray = []
        this.self.gxArray = []
        this.self.gyArray = []
        this.self.gzArray = []
        this.self.tLArray = []
        this.self.tMArray = []
        this.self.tRArray = []
    }
    get_data_array = (type) => {
        return type.map(name => this.self[name]);
    };
    set_buffer_size = (buffer_size) => {
        this.bufferSize = buffer_size
    }
    get_buffer_size = () => {
        return this.bufferSize
    }

    send_command = async (data_req_type) => {
        
        this.robotData['receivedData'] = false;
        
        let packet = [this.PACKET_TYPE.DATA_PACKET, data_req_type.value]
        await this.sendPassthrough(packet);

        // wait for response
        this.timeout_count = 0
        let me = this

        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    me.robotData['receivedData'] = false

                    // update arrays based on data_req_type
                    data_req_type.arrays.forEach((arrayName, index) => {
                        const data = me.robotData['messageData'][data_req_type.value][data_req_type.names[index]];
                        me.self[arrayName].push(data);
                        if (me.self[arrayName].length > me.bufferSize) {
                            me.self[arrayName].shift();
                        }
                    });
                    resolve("done");
                } else {
                    if (me.timeout_count < me.TIMEOUT_MAX) {
                        me.lrTimeoutID = window.setTimeout(f, 5);
                    } else {
                        resolve("failure");//me.TIMEOUT_STR);
                    }                    
                    me.timeout_count += 10;
                }
            }
            window.setTimeout(f, 5);
        });



        /*

            this.self.tLArray.push(unpackedData[0]);
            this.self.tMArray.push(unpackedData[1]);
            this.self.tRArray.push(unpackedData[2]);
            if (this.self.tLArray.length > this.bufferSize) this.self.tLArray.shift();
            if (this.self.tMArray.length > this.bufferSize) this.self.tMArray.shift();
            if (this.self.tRArray.length > this.bufferSize) this.self.tRArray.shift();
        */
    }

    get_data_array = (value) => {

        switch (value) {
            case this.self.READ_ATT.value:
                return [this.self.rArray, this.self.pArray, this.self.yArray];
            case this.self.READ_ULTRA.value:
                return [this.self.uArray];
            case this.self.READ_ACC.value:
                return [this.self.axArray, this.self.ayArray, this.self.azArray];
            case this.self.READ_GYR.value:
                return [this.self.gxArray, this.self.gyArray, this.self.gzArray];
            case this.self.READ_TRACK.value:
                return [this.self.tLArray, this.self.tMArray, this.self.tRArray];
        }
    };

    clearReadState = () => {

        this.read_loop = {
            targetLen: 0,
            targetLenOff: 0,
            header: 0,
            hasTargetLength: false,
            hasHeader: false
        }

        this.read_buffer = {
            data: [],
        }
        
        this.robotData = {
            scanEnd: false,
            scanData: [],
            connectEnd: false,
            connectState: 0,
            connectFirmware: false,
            receivedData: false,
            waitFlag: false,
            waitData: "",
            messageData: {
                [this.DATA_TYPE.ACC_DATA]: {
                    x: 0, y: 0, z: 0
                },
                [this.DATA_TYPE.GYRO_DATA]: {
                    x: 0, y: 0, z: 0
                },
                [this.DATA_TYPE.EULER_DATA]: {
                    roll: 0, pitch: 0, yaw: 0
                },
                [this.DATA_TYPE.ULTRASONIC_DATA]: {
                    distance: 0
                },
                [this.DATA_TYPE.TRACKING_DATA]: {
                    left: 0, middle: 0, right: 0
                }
            }
        }
    }

    clearLRTimeout = () => {
        
        try {
            if (this.lrTimeoutID !== null) {
                window.clearTimeout(this.lrTimeoutID);
                this.lrTimeoutID = null;
            }
        } catch (err) { }
    }
    
    connect_usb = async() => {

        this.clearLRTimeout();
        this.clearReadState();
        this.can_process = false;

        await sleep(500);

        // - Request a port and open a connection.
        try {
            const usbVendorId = 0x10C4;
            this.port = await navigator.serial.requestPort({ filters: [{ usbVendorId }]});
        } catch(err) {
            console.log("error", err)
        }
        // - Wait for the port to open.
        await this.port.open({ baudRate: 115200, bufferSize: 2048 });

        this.reader = this.port.readable.getReader();
        
        this.readLoop();
        await sleep(2000);
    }

    connect = async () => {
        
        let me = this;
        return new Promise(async function (resolve, reject) {

            var m = function() {
                resolve("done");
            }
            return me.connect_usb().then(() => {
                me.lrTimeoutID = window.setTimeout(m, 4000);
            }).catch((err) => {
                resolve("error")
            });
        });
    }

    setup = async () => {
        let me = this;
        return new Promise(async function (resolve, reject) {

            var m = function() {
                resolve("done");
            }
            return me.connect_usb().then(() => {
                me.lrTimeoutID = window.setTimeout(m, 4000);
            }).catch((err) => {
                resolve("error")
            });
        });
    }

    connect_wifi = async(ssid) => {
        await this.connectRobot(ssid);
    };

    readLoop = async() => {
        while (true) {
            let output = await this.update_buffer();
            if (output === -1) {
                this.reader.releaseLock();
                break;
            } else if (output === -2) {
                try {
                    this.reader = this.port.readable.getReader();
                } catch {
                    this.reader.releaseLock();
                    break;                    
                }
            }
            if (this.can_process === true) {
                this.process_buffer();
            }
        }
    }

    update_buffer = async() => {
        try {
            const { value, done } = await this.reader.read()
            let nowPacket = new Uint8Array(value.buffer);
            if (this.can_process === true) {
                this.read_buffer.data = [...this.read_buffer.data , ...nowPacket]
            }
            if (done) {
                return -1;
            } else {
                return 0;
            }
        } catch (err) {
            return -2
        }
    };

    process_buffer = async() => {
        if (this.read_loop.hasHeader === false) {
            // Have Header Now
            this.read_loop.header = this.read_buffer.data[0]
            this.read_loop.hasHeader = true
    
            // Not enough data for length byte
            if (this.read_buffer.data.length < 3) {
                return;
            }
    
            this.read_loop.targetLen = this.read_buffer.data[1]
            this.read_loop.targetLenOff = 2
            this.read_loop.hasTargetLength = true
    
            // Check if the rest of the packet is in the buffer - if not, return
            let fullLength = (this.read_loop.targetLen + this.read_loop.targetLenOff)
            if (this.read_buffer.data.length < fullLength) {
                return;
            }
    
            // Read Current Packet
            let myPacket = this.read_buffer.data.slice(0, fullLength)
    
            // Process Packet
            this.process_serial(myPacket)
    
            // Update Buffer without throwing out extra, if extra
            this.read_buffer.data = this.read_buffer.data.slice(fullLength, this.read_buffer.data.length)
    
            // Reset Parameters
            this.clear_packet_info()       
    
        } else {
            // Does Not Already Have Target Length?
            if (this.read_loop.hasTargetLength !== true) {
                
                // Not enough data for length byte
                if (this.read_buffer.data.length < 3) {
                    return;
                }
    
                this.read_loop.targetLen = this.read_buffer.data[1]
                this.read_loop.targetLenOff = 2
                this.read_loop.hasTargetLength = true
            }
            
            // Check if the rest of the packet is in the buffer - if not, return
            let fullLength = (this.read_loop.targetLen + this.read_loop.targetLenOff)
            if (this.read_buffer.data.length < fullLength) {
                return;
            }
            
            // Read Current Packet
            let myPacket = this.read_buffer.data.slice(0, fullLength)
    
            // Process Packet
            this.process_serial(myPacket)
    
            // Update Buffer without throwing out extra, if extra
            this.read_buffer.data = this.read_buffer.data.slice(fullLength, this.read_buffer.data.length)
    
            // Reset Parameters
            this.clear_packet_info()
        }
    };

    clear_packet_info = () => {
        this.read_loop.header = 0
        this.read_loop.hasHeader = false
        this.read_loop.targetLen = 0
        this.read_loop.hasTargetLength = false
        this.read_loop.targetLenOff = 0
    }

    process_serial = async(dataBytes) => {
        //console.log("serial", dataBytes)
        this.packetFlag = false
        this.packetHaveLen = false
        this.currentLen = 0
        //console.log(dataBytes)
        // Switch on Header Value
        switch (dataBytes[0]) { // dataBytes[1] is the length

            case this.LOCOROVER_MSGS.SSID_LIST_ITEM: { // Received SSID List Item
                //console.log("scan item")
                let name = dataBytes.slice(2, 2 + dataBytes[1]);
                //console.log(name)
                name = String.fromCharCode.apply(null, name);
                this.robotData['scanData'].push(name)
                break
            }
            case this.LOCOROVER_MSGS.SSID_LIST_END: { // Received SSID List End
                //console.log("scan end")
                this.robotData['scanEnd'] = true
                break
            }
            case this.LOCOROVER_MSGS.WIFI_CONNECT: { // Received Wifi Connect Response
                //console.log("connect end")
                this.robotData['connectEnd'] = true
                this.robotData['connectState'] = dataBytes[2]
                //console.log(dataBytes[2])
                break
            }
            case this.LOCOROVER_MSGS.WIFI_DISCONNECT: { // Received Wifi Disconnect Response
                //console.log("disconnect end")
                this.robotData['connectEnd'] = true
                this.robotData['connectState'] = dataBytes[2]
                //console.log(dataBytes[2])
                break
            }
            case this.LOCOROVER_MSGS.PT_VERSION: { // Received Passthrough Version
                //console.log('version info', dataBytes[2], dataBytes[3])
                const timeSinceDebug = performance.now() - this.debug_time;
                //console.log("FW Version, Time since debug_time (ms):", timeSinceDebug);
                this.robotData['ptFWVersion'] = dataBytes[2]
                this.robotData['ptFWRevision'] = dataBytes[3]
                this.robotData['receivedData'] = true;
                break
            }
            case this.LOCOROVER_MSGS.WIFI_PASSTHROUGH: { // Received Passthrough Data
                //console.log("pass through resp")
                this.handlePTResponse(dataBytes);
                break
            }
            case this.LOCOROVER_MSGS.DEBUG_PACKET: {
                console.log("debug packet")
                let name = dataBytes.slice(2, 2 + dataBytes[1] - 1);
                console.log(name)
                name = String.fromCharCode.apply(null, name);
                console.log(name);
            }


        }

    }

    handlePTResponse = (dataBytes) => {

        const length = dataBytes[1];
        const packet_type = dataBytes[2];

        //console.log(dataBytes)
        //console.log("packet type", packet_type)

        //const response_time = performance.now() - this.debug_time;
        //console.log("passthrough echo response time (ms):", response_time)

        // switch on packet_type
        if (packet_type === this.PACKET_TYPE.DATA_PACKET) {
            const data_type = dataBytes[3];
            const packet_data = dataBytes.slice(4);

            switch (data_type) {
                case this.DATA_TYPE.TRACKING_DATA: {
                    const unpackedData = [];
                    for (let i = 0; i < packet_data.length; i += 2) {
                        unpackedData.push((packet_data[i] << 8) | packet_data[i + 1]);
                    }
                    this.robotData['messageData'][data_type]['left'] = unpackedData[0];
                    this.robotData['messageData'][data_type]['middle'] = unpackedData[1];
                    this.robotData['messageData'][data_type]['right'] = unpackedData[2];
                    break;
                }
                case this.DATA_TYPE.ULTRASONIC_DATA: {
                    // Unpack data using 'f' format (32-bit float)
                    const unpackedData = [];
                    for (let i = 0; i < packet_data.length; i += 4) {
                        const buffer = new ArrayBuffer(4);
                        const view = new DataView(buffer);
                        packet_data.slice(i, i + 4).forEach((byte, index) => view.setUint8(index, byte));
                        unpackedData.push(view.getFloat32(0, true)); // true for little-endian
                    }
                    this.robotData['messageData'][data_type]['distance'] = unpackedData[0];
                    this.self.uArray.push(unpackedData[0]);
                    break;
                }
                case this.DATA_TYPE.ACC_DATA:
                case this.DATA_TYPE.GYRO_DATA:
                case this.DATA_TYPE.EULER_DATA: {
                    const unpackedData = [];
                    for (let i = 0; i < packet_data.length; i += 2) {
                        unpackedData.push((packet_data[i] << 8) | packet_data[i + 1]);
                    }

                    if (data_type === this.DATA_TYPE.ACC_DATA) {
                        this.robotData['messageData'][data_type]['x'] = unpackedData[0];
                        this.robotData['messageData'][data_type]['y'] = unpackedData[1];
                        this.robotData['messageData'][data_type]['z'] = unpackedData[2];

                    } else if (data_type === this.DATA_TYPE.GYRO_DATA) {
                        this.robotData['messageData'][data_type]['x'] = unpackedData[0];
                        this.robotData['messageData'][data_type]['y'] = unpackedData[1];
                        this.robotData['messageData'][data_type]['z'] = unpackedData[2];

                    } else if (data_type === this.DATA_TYPE.EULER_DATA) {
                        this.robotData['messageData'][data_type]['roll'] = unpackedData[0];
                        this.robotData['messageData'][data_type]['pitch'] = unpackedData[1];
                        this.robotData['messageData'][data_type]['yaw'] = unpackedData[2];
                        console.log(this.robotData['messageData'][data_type])
                    }

                }
            }
        }


        this.robotData['receivedData'] = true;
        this.robotData['waitData'] =  [];
    }

    disconnect = async () => {
        try {
            this.can_process = false;
            if (this.reader) {
                if (this.port && this.port.readable && this.port.readable.locked) {
                    await this.reader.cancel();
                    this.reader.releaseLock();
                }
            }
            if (this.writer) {
                await this.writer.releaseLock();
            }
            if (this.port) {
                if (this.port.readable.locked) {
                    await this.reader.cancel();
                    this.reader.releaseLock();
                }
                await this.port.close();
                this.port = null;
            }
            console.log('Disconnected from the serial port');
        } catch (error) {
            console.error('Failed to disconnect from the serial port:', error);
        }
    }

    disconnect_quick = async() => {
        try {
            await this.disconnect_wifi_quick();
            this.disconnect(); // for usb
        } catch (err) {
        } finally {
            this.clearLRTimeout();
            this.clearReadState();
        }
    }
    
    disconnect_wifi_quick = async() => {
        const packet = new Uint8Array([this.LOCOROVER_MSGS.WIFI_DISCONNECT, 1, 0]); // disconnect, length, 0
        await this.webserial_write(packet);
        await sleep(250);
    }

    webserial_write = async (data) => {
        //console.log("data write", data)

        if (this.can_process === false) {
            this.can_process = true
        }
        //console.log("write:", data)
        try {
            const writer = this.port.writable.getWriter();
            await writer.write(data);
            writer.releaseLock();
        } catch (err) {
            console.log("write error", err)
        }
    }

    wifi_scan = async() => {

        await this.getVersion();

        const startScanPacket = new Uint8Array([this.LOCOROVER_MSGS.WIFI_SCAN, 0x01, 0x00]);
        await this.webserial_write(startScanPacket);

        // wait for response - this.robotData['scanEnd'] === true
        return await new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                if (this.robotData.scanEnd === true) {
                    clearInterval(interval);
                    resolve("done");
                }
            }, 100); // Check every 100ms
            // reject the promise if the flag doesn't change within a certain time
            setTimeout(() => {
                clearInterval(interval);
                resolve("timeout");
            }, SCAN_TIMEOUT); // Timeout after RESP_TIMEOUT seconds
        });
    }

    connectRobot = async(ssid) => {
        const ssidBytes = new TextEncoder().encode(ssid);
        const ssidLength = ssidBytes.length;
        const connectPacket = new Uint8Array(2 + ssidLength);
        connectPacket[0] = this.LOCOROVER_MSGS.WIFI_CONNECT;
        connectPacket[1] = ssidLength;
        connectPacket.set(ssidBytes, 2);
        await this.webserial_write(connectPacket);

        this.robotData['connectEnd'] = false;
        this.robotData['connectState'] = 0;

        let me = this;
        
        return new Promise(function (resolve, reject) {
            
            let m = function () {
                resolve("done");
            }

            let f = function () {
                if (me.robotData['connectEnd'] === true) {
                    if (me.robotData['connectState'] !== me.CONNECT_STATES.CONNECT_OK) {
                        reject("Could Not Connect To The Robot. Please Try Running the Program Again.");
                    } else {
                        window.setTimeout(m, 2500);
                    }
                } else {
                    window.setTimeout(f, 5);
                }
            }

            window.setTimeout(f, 5);
        });
    }

    disconnectRobot = async() => {
        const disconnectPacket = new Uint8Array([this.LOCOROVER_MSGS.WIFI_DISCONNECT, 0x01, 0x00]);
        await this.webserial_write(disconnectPacket);

        // Wait for response - this.robotData.connectEnd === true
        await new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                if (this.robotData.connectEnd === true) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100); // Check every 100ms
            // reject the promise if the flag doesn't change within a certain time
            setTimeout(() => {
                clearInterval(interval);
                reject(new Error("Connection timeout"));
            }, RESP_TIMEOUT); // Timeout after RESP_TIMEOUT seconds
        });
    }

    sendPassthrough = async(data) => {
        const dataLength = data.length;
        const passthroughPacket = new Uint8Array(2 + dataLength);
        passthroughPacket[0] = this.LOCOROVER_MSGS.WIFI_PASSTHROUGH;
        passthroughPacket[1] = dataLength;
        passthroughPacket.set(data, 2);
        await this.webserial_write(passthroughPacket);
    }

    setLights = async(colors) => {

        colors = colors.map(color => {
            if (color < 0) return 0;
            if (color > 255) return 255;
            return Math.floor(color);
        });

        let packet = [this.PACKET_TYPE.LIGHTS_PACKET]
        for (let i = 0; i < colors.length; i++) {
            packet.push(colors[i]);
        }

        await this.sendPassthrough(packet);
    }

    setBuzzer = async(noteId, octave, duration) => { // 8-bit uint, 8-bit uint, 16-bit uint

        if (!this.LR_NOTE_MAPPING.hasOwnProperty(noteId)) {
            throw new Error("Invalid noteId");
        }
        noteId = this.LR_NOTE_MAPPING[noteId];
        if (octave < 0 || octave > 8) {
            throw new Error("Octave must be a value betwee (0-8)");
        }

        if (duration < 0 || duration > 65535) {
            throw new Error("Duration must be a value between 0 and 65535");
        }

        let packet = [
            this.PACKET_TYPE.SOUND_PACKET, 
            noteId, octave, 
            duration & 0xFF, (duration >> 8) & 0xFF
        ]

        await this.sendPassthrough(packet);
    }

    setArmAngles = async(chassis_angle, shoulder_angle, elbow_angle, wrist_angle, claws_angle) => {
        // deg, deg, deg, deg, deg
        const angles = [chassis_angle, shoulder_angle, elbow_angle, wrist_angle, claws_angle].map(angle => {
            if (angle < 0) return 0;
            if (angle > 180) return 180;
            return Math.floor(angle);
        });
        angles.forEach(angle => packet.push(angle));

        let packet = [
            this.PACKET_TYPE.ARM_PACKET, this.ARM_TYPE.ARM_ANGLES,
            ...angles
        ]

        await this.sendPassthrough(packet);

        // inherent wait for arm to move
        await sleep(ARM_MOVE_WAIT);
    }

    setArmPosition = async(x, y, z, wrist_angle, claws_angle) => { // cm, cm, cm, deg, deg

        const positions = [x, y, z].map(pos => {
            if (pos < 0) return 0;
            if (pos > ARM_POS_MAX) return ARM_POS_MAX;
            return Math.floor(pos);
        });

        const angles = [wrist_angle, claws_angle].map(angle => {
            if (angle < 0) return 0;
            if (angle > 180) return 180;
            return Math.floor(angle);
        });

        let packet = [
            this.PACKET_TYPE.ARM_PACKET, this.ARM_TYPE.ARM_POSITION,
            ...positions, ...angles
        ];

        await this.sendPassthrough(packet);

        // inherent wait for arm to move
        await sleep(ARM_MOVE_WAIT);
    }

    setDrive = async(direction, speed, isWait, duration = 0) => { 

        if (!Object.values(this.LR_DRIVE_MAPPING).includes(direction)) {
            throw new Error("Invalid direction value");
        }
        
        if (speed < 0 || speed > DRIVE_SPEED_MAX) {
            throw new Error(`Speed must be a value between 0 and ${DRIVE_SPEED_MAX}`);
        }
        if (isWait !== 0 && isWait !== 1) {
            throw new Error("Wait must be either 0 or 1");
        }
        if (duration < 0 || duration > 65535) {
            throw new Error("Duration must be a value between 0 and 65535");
        }

        let packet = [
            this.PACKET_TYPE.DRIVE_PACKET,
            direction,
            speed,
            isWait,
            duration & 0xFF, (duration >> 8) & 0xFF
        ];

        await this.sendPassthrough(packet);
    
    }

    getVersion = async () => {

        this.debug_time = performance.now();

        let packet = new Uint8Array([this.LOCOROVER_MSGS.PT_VERSION, 0x01, 0x00]);

        await this.webserial_write(packet);

        this.robotData['receivedData'] = false;
        this.robotData['waitData'] =  [];

        // wait for response
        this.timeout_count = 0
        let me = this

        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    me.robotData['receivedData'] = false
                    resolve("done");
                } else {
                    if (me.timeout_count < me.TIMEOUT_MAX) {
                        me.lrTimeoutID = window.setTimeout(f, 5);
                    } else {
                        resolve("failure");//me.TIMEOUT_STR);
                    }                    
                    me.timeout_count += 10;
                }
            }
            window.setTimeout(f, 5);
        });


        
    }

    getData = async (data_type) => {

        if (!Object.values(this.DATA_TYPE).includes(data_type)) {
            throw new Error("Invalid data_type value");
        }

        this.debug_time = performance.now();

        let data = [this.PACKET_TYPE.DATA_PACKET, data_type]

        await this.sendPassthrough(data)

        this.robotData['receivedData'] = false;
        this.robotData['waitData'] =  [];

        // wait for response
        this.timeout_count = 0
        let me = this

        return new Promise(function (resolve, reject) {
            var f = function () {
                if (me.robotData['receivedData'] === true) {
                    me.robotData['receivedData'] = false
                    resolve("done");
                } else {
                    if (me.timeout_count < me.TIMEOUT_MAX) {
                        me.lrTimeoutID = window.setTimeout(f, 5);
                    } else {
                        resolve("failure");//me.TIMEOUT_STR);
                    }                    
                    me.timeout_count += 10;
                }
            }
            window.setTimeout(f, 5);
        });
    }


  
}

export { LocoRover };